import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import SignupFlow from './components/SignupFlow';
import Button from '../../components/common/Button';
import { Link } from 'react-router-dom';

export default function Signup() {
  const { initiateGoogleSignup, user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showSignupFlow, setShowSignupFlow] = useState(false);

  // If user is authenticated, check if they need to complete onboarding
  useEffect(() => {
    if (isAuthenticated && user) {
      if (!user.onboardingComplete) {
        console.log('User authenticated but needs to complete onboarding');
        setShowSignupFlow(true);
      } else {
        console.log('User already completed onboarding, redirecting to dashboard');
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, user, navigate]);

  const handleGoogleSignup = (e) => {
    e.preventDefault();
    console.log('Initiating Google signup...');
    initiateGoogleSignup();
  };

  // If showing signup flow, render the multi-step form
  if (showSignupFlow) {
    return <SignupFlow user={user} />;
  }

  // Otherwise show the initial signup page
  return (
    <div className="min-h-screen bg-gradient-to-b from-sand to-white">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex items-center gap-3 mb-8">
          <Shield className="h-8 w-8 text-primary" />
          <span className="text-2xl font-bold text-primary">Stickr</span>
        </div>

        <div className="bg-white rounded-2xl shadow-stickr-sm p-8 max-w-md mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-navy mb-2">
              Create Your Account
            </h1>
            <p className="text-navy/70">
              Get started with secure email verification for your organization
            </p>
          </div>

          <Button
            onClick={handleGoogleSignup}
            className="w-full flex items-center justify-center gap-2 bg-white border-2 border-light-purple text-navy hover:bg-light-purple/10 mb-4"
          >
            <img 
              src="https://www.google.com/favicon.ico" 
              alt="Google" 
              className="w-5 h-5"
            />
            Sign up with Google
          </Button>

          <div className="text-center mt-6">
            <p className="text-sm text-navy/70">
              Already have an account?{' '}
              <Link to="/login" className="text-primary font-medium hover:underline">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}